import React, { ReactNode } from 'react';
import { Typography, Select, MenuItem } from '@mui/material';
import { FieldInputProps } from 'formik';
import { capitalize } from 'lodash';
import { IconArrowDown } from '../../../../utils/icons';
import { ISelectOption } from './constants';

interface SelectProps {
  children?: ReactNode;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  options?: Array<string>;
  objectOptions?: Array<ISelectOption>;
  value?: any;
  onChange?: (value: any) => void;
  fieldProps?: FieldInputProps<any>;
}

export function SelectPanel({
  placeholder,
  readOnly,
  disabled,
  children,
  options,
  objectOptions,
  value: val,
  onChange,
  fieldProps,
}: SelectProps) {
  return (
    <Select
      readOnly={readOnly}
      disabled={disabled}
      value={val}
      onChange={(e: any) => onChange?.(e.target.value)}
      {...fieldProps}
      size="small"
      className="bg-surface-2 rounded-xl"
      placeholder={placeholder}
      displayEmpty
      MenuProps={{
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        PaperProps: { sx: { maxHeight: 320, borderRadius: '12px', mt: 0.5 } },
      }}
      renderValue={(value: any) => {
        const valToRender = val !== undefined ? val : value;

        return typeof valToRender === 'string'
          ? valToRender
          : valToRender?.label ||
              valToRender?.name ||
              valToRender?.brand?.name || (
                <Typography color="var(--muted)">{placeholder}</Typography>
              );
      }}
      sx={{
        '& fieldset': { border: 'none' },
      }}
      IconComponent={(_props) => {
        const rotate = _props.className.toString().includes('iconOpen');
        return (
          <div
            style={{
              position: 'absolute',
              cursor: 'pointer',
              pointerEvents: 'none',
              right: 10,
              transform: rotate ? 'rotate(180deg)' : 'none',
            }}
          >
            <IconArrowDown />
          </div>
        );
      }}
    >
      {children}
      {options?.map((option) => (
        <MenuItem value={option} key={option}>
          {capitalize(option)}
        </MenuItem>
      ))}
      {objectOptions?.map((option, index) => (
        <MenuItem value={option.value} key={`options-list-${index}`}>
          {capitalize(option.label)}
        </MenuItem>
      ))}
    </Select>
  );
}
